import { render, staticRenderFns } from "./AutomobileAccessory.vue?vue&type=template&id=48e71871&"
import script from "./AutomobileAccessory.vue?vue&type=script&lang=js&"
export * from "./AutomobileAccessory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports